export default __webpack_public_path__ + "static/media/python.d8fdc95f.png";